module.exports = __webpack_public_path__ + "img/person-using-charger.7982188a.png";